import React from 'react';
import "bootstrap-icons/font/bootstrap-icons.css";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

export default function ColumnHeader(props) {
    let beatDesc = props.description;
    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
          { beatDesc }
        </Tooltip>
    );

    return (
        <div className="d-flex justify-content-between">
            <h2 style={{fontSize: "1.3rem"}}>{ props.title }</h2>
            {/* <i class="bi bi-info-circle"></i> */}
            <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
            >
                <i className="bi bi-info-circle" role="button" tabIndex="0"></i>
            </OverlayTrigger>
        </div>
    )
}
